import { createFormAction } from 'redux-form-saga'

const getAllModemTypesAction = createFormAction('GET_ALL_MODEM_TYPES')
const getModemTypeAction = createFormAction('GET_MODEM_TYPE')
const createModemTypeAction = createFormAction('CREATE_MODEM_TYPE')
const updateModemTypeAction = createFormAction('UPDATE_MODEM_TYPE')
const deleteModemTypeAction = createFormAction('DELETE_MODEM_TYPE')

export {
  getAllModemTypesAction,
  getModemTypeAction,
  createModemTypeAction,
  updateModemTypeAction,
  deleteModemTypeAction,
}
